// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  worldId: __t.u64().primaryKey().name("world_id"),
  timeOfDay: __t.f32().name("time_of_day"),
  weather: __t.string(),
  cycleSeconds: __t.u32().name("cycle_seconds"),
  updatedAt: __t.timestamp().name("updated_at"),
});
